import { styled } from '@mui/material';

export const OuterContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[900],
  borderRadius: theme.spacing(1),
}));

export const Container = styled('div')(({ theme }) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '420px',
  paddingBottom: theme.spacing(1),
  paddingTop: theme.spacing(1),
  position: 'relative',
}));

export const InnerContainer = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(1),
  height: 0,
  overflow: 'hidden',
  paddingBottom: '150%',
}));

export const Image = styled('img')(({ theme }) => ({
  borderRadius: theme.spacing(1),
  display: 'block',
  objectFit: 'cover',
  objectPosition: 'center',
  width: '100%',
}));
